import { useState, useCallback } from "react"

const useManageExpandedRowIds = (initialState = []) => {
  const [state, setState] = useState(initialState)
  const updateState = newItem => {
    setState(prevState => {
      const exists = prevState.some(item => item === newItem)
      return exists ? prevState.filter(item => item !== newItem) : [newItem]
    })
  }

  const doesIdExist = useCallback(id => state.some(item => item === id), [state])

  return [state, updateState, doesIdExist]
}

export default useManageExpandedRowIds
